import React from "react";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-sm-6">{currentYear} © Hub Business Center.</div>
          <div className="col-sm-6">
            <div className="text-sm-end d-none d-sm-block">
              Crafted with <i className="mdi mdi-heart text-danger"></i> by&nbsp;
              <a
                href="http://codebucks.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted"
              >
                InsaSoft
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
